import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { ALTER_ERROR, useSnackbar } from 'storfox-snackbar'
import { prop, propOr } from 'ramda'

import { DashboardLayout } from '~/components/Layouts'
import * as ROUTES from '~/constants/routes'
import * as NAV from '~/constants/nav-titles'
import ErrorLink from '~/components/ErrorLink'
import { INTEGRATION_TABS } from '~/constants/tabs'
import useMessages from '~/hooks/useMessages'

import { useIntegrationHistory, useStoreFrontDetail, useStoreFrontRemove, useStoreFrontUpdate } from '../../hooks'
import StorefrontIntegrationUpdateForm from '../../components/Storefront/StorefrontIntegrationUpdateForm'

function StorefrontIntegrationUpdateContainer () {
  const { guid, tab } = useParams()

  const snackbar = useSnackbar()
  const navigate = useNavigate()
  const messages = useMessages()
  const storeFrontDetail = useStoreFrontDetail(guid)
  const storeFrontUpdate = useStoreFrontUpdate(guid)
  const storeFrontRemove = useStoreFrontRemove()

  const title = prop('name', storeFrontDetail.detail)
  const type = propOr('', 'type', storeFrontDetail.detail)

  const detailPath = generatePath(ROUTES.INTEGRATION_UPDATE_PATH, { guid, type, tab: INTEGRATION_TABS.GENERAL })

  const historyAutoSend = Boolean(guid && tab === INTEGRATION_TABS.LOGS)
  const integrationHistory = useIntegrationHistory(guid, historyAutoSend)

  const handleSubmit = formValues =>
    storeFrontUpdate.update(formValues)
      .then(() => {
        snackbar({ message: messages.UPDATE_SUCCESS })
        navigate(detailPath)
      })
      .catch(error => {
        const message = <ErrorLink error={error} />
        snackbar({ message, type: ALTER_ERROR })
      })

  const isLoading = (
    storeFrontDetail.isLoading ||
    storeFrontUpdate.isLoading
  )

  const handleRemove = () =>
    storeFrontRemove.delete({ guids: [guid] })
      .then(() => navigate(ROUTES.INTEGRATION_LIST_PATH, { replace: true }))

  const breadcrumbs = { title }

  return (
    <DashboardLayout
      isLoading={storeFrontDetail.isLoading}
      activeNav={NAV.INTEGRATION}
      breadcrumbs={breadcrumbs}
    >
      <StorefrontIntegrationUpdateForm
        isLoading={isLoading}
        pageTitle={title}
        pageTitleLoading={storeFrontDetail.isLoading}
        onSubmit={handleSubmit}
        onRemove={handleRemove}
        initialValues={storeFrontDetail.detail}
        history={integrationHistory}
      />
    </DashboardLayout>
  )
}

export default StorefrontIntegrationUpdateContainer
